import React from "react";
import { Box, Button, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import startCase from "lodash/startCase";

import { tl } from "../../../components/translate";
import VitalsPopUp from "./VitalsPopUp";
import { vitals } from "./VitalRow";
import useAssessmentLabel from "../../../hooks/useAssessmentLabel";
import { IVitals } from "../../../interfaces/AssessmentInterfaces";

// @ts-expect-error - css
import styles from "../Assessment.module.css";

function applyTypes(assessmentVitals: IVitals[]): Array<IVitals> {
  return assessmentVitals?.map((item) => {
    const relatedType = vitals.find((vital) => vital.name === item.name)?.type || "text";
    return { ...item, type: relatedType };
  });
}

const Vitals = ({
  assessmentVitals,
  onChange
}: {
  assessmentVitals: IVitals[];
  onChange: (data: IVitals[]) => void;
}): React.ReactNode => {
  const assessmentLabels = useAssessmentLabel();
  const aVitals = applyTypes(assessmentVitals);
  const [dialog, setDialog] = React.useState(false);

  return (
    <Box className={styles.assessmentRow} height="auto" alignItems="flex-start">
      <Box className={styles.assessmentLabel} pt="4px">
        <Typography component="span" fontWeight="600">
          {assessmentLabels.vitals}
        </Typography>
      </Box>
      <Box className={styles.assessmentField}>
        <Box>
          {aVitals?.map((v, index) => (
            <Box key={v.name} display="flex" justifyContent="space-between">
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Typography>{startCase(v.name)}:</Typography>

                <Typography sx={{ fontWeight: 600 }}>
                  {v.reading}
                  {v.unit && `, ${v.unit}`}
                  {v.extraInfo && `, ${v.extraInfo}`}
                </Typography>
              </Box>

              <CloseIcon
                data-testmation="vitals.RemoveButton"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  const newVitals = assessmentVitals;
                  newVitals.splice(index, 1);
                  onChange(newVitals);
                }}
              />
            </Box>
          ))}
        </Box>

        <Button
          onClick={() => setDialog(true)}
          data-testmation="vitals.AddNewButton"
          size="small"
          variant="outlined"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            marginTop: aVitals.length > 0 ? 1 : 0
          }}
        >
          {tl("assessment.addNew")}
        </Button>
      </Box>

      <VitalsPopUp
        isOpen={dialog}
        onClose={() => setDialog(false)}
        aVitals={aVitals}
        onSave={onChange}
      />
    </Box>
  );
};

export default Vitals;
